const PREFIX = 'DASHBOARD_V2_TRACK_ITEMS';

const constants = {
  SAVE_TRACK_ITEMS: `${PREFIX}/SAVE_TRACK_ITEMS`,
  SAVE_TRACK_ITEMS_DONE: `${PREFIX}/SAVE_TRACK_ITEMS_DONE`,
};

export default constants;
